import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, LeafIcon, ChefHatIcon, HandshakeIcon } from 'lucide-react';
import { Hero } from '../components/home/Hero';
import { Destinations } from '../components/home/Destinations';
import { TwoServices } from '../components/home/TwoServices';
import { SectionTitle } from '../components/SectionTitle';
import { tour } from '../data/destinations';
const values = [{
  icon: ChefHatIcon,
  title: 'Fait maison, tous les matins',
  text: 'Pâte pétrie et garnitures mijotées au laboratoire, à deux rues du camion.'
}, {
  icon: LeafIcon,
  title: 'Produits d’ici',
  text: 'Viandes, légumes et fromages de producteurs à moins de 40 km.'
}, {
  icon: HandshakeIcon,
  title: 'Recettes de là-bas',
  text: 'Chaque recette est calée avec quelqu’un qui a grandi avec elle.'
}];
export function Home() {
  return <main data-id="element-316" data-mp="3owcfbehct82s">
      <Hero data-id="element-317" data-mp="3ow421lhbk0r2" />
      <Destinations data-id="element-318" data-mp="3ovkk44ro5cd1" />
      <TwoServices data-id="element-319" data-mp="3ov2g2lyrltuk" />

      <section className="paper-texture border-b-[3px] border-noir py-16 md:py-24" data-id="element-320" data-mp="3oyqarofy4mav">
        <div className="mx-auto grid max-w-7xl gap-12 px-4 md:px-8 lg:grid-cols-[1fr_1.1fr]" data-id="element-321" data-mp="30up121ymyedg">
          <div data-id="element-322" data-mp="2vyhwodlw1axm">
            <SectionTitle kicker="Fait maison" title={<>
                  Un produit d’ici,
                  <br data-id="element-324" data-mp="2mvyt1raa2uab" />
                  des recettes de là-bas
                </>} intro="On ne prétend pas cuisiner comme à Buenos Aires ou à La Nouvelle-Orléans. On cuisine avec ce que la région nous donne, en respectant la recette d’origine." data-id="element-323" data-mp="2vvvp4dyzyvfe" />
            <ul className="mt-8 space-y-5" data-id="element-325" data-mp="287kp1d14kzs6">
              {values.map(value => <li key={value.title} className="flex gap-4" data-id="element-326" data-mp="239axdcem0hbb">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center border-[3px] border-noir bg-jaune" data-id="element-327" data-mp="236y4w5b86ok0">
                    <value.icon className="h-5 w-5" aria-hidden="true" data-id="element-328" data-mp="1u8cp2hx51nmx" />
                  </span>
                  <div data-id="element-329" data-mp="1kkqmfd8pqadf">
                    <h3 className="font-display text-lg uppercase leading-none" data-id="element-330" data-mp="1kk7dgm11iwbj">{value.title}</h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-noir/70" data-id="element-331" data-mp="1omu3che5i763">{value.text}</p>
                  </div>
                </li>)}
            </ul>
          </div>

          <div className="relative" data-id="element-332" data-mp="1fldzytlr75bd">
            <img src="https://cdn.magicpatterns.com/uploads/wVqTRsNcF6f5fBnhRnb7vw/1000000075.jpg" alt="Bol de crawfish boil louisianais : écrevisses, saucisse fumée et maïs" className="h-full min-h-[320px] w-full border-[4px] border-noir object-cover shadow-hard" data-id="element-333" data-mp="1fmfej81za9xu" />
            <p className="absolute bottom-5 left-5 right-5 border-[3px] border-noir bg-creme px-4 py-3 font-script text-2xl leading-tight" data-id="element-334" data-mp="1tl5cepwmgdn9">
              « Le crawfish boil du dimanche, c’est la recette de la grand-mère de Thomas. »
            </p>
          </div>
        </div>
      </section>

      <section className="border-b-[3px] border-noir bg-jaune py-16 md:py-24" data-id="element-335" data-mp="2r240bw3hx2x2">
        <div className="mx-auto max-w-7xl px-4 md:px-8" data-id="element-336" data-mp="fkizn7qyl4st">
          <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-337" data-mp="amz9pakwf3l1">
            <SectionTitle kicker="La tournée" title="Où est le camion cette semaine ?" data-id="element-338" data-mp="akmu342m55b5" />
            <Link to="/ou-nous-trouver" className="inline-flex items-center gap-2 border-b-[3px] border-noir pb-1 font-display text-sm uppercase tracking-wide transition-colors duration-150 ease-out hover:text-rouge" data-id="element-339" data-mp="kcsmug0ovqre">
              Voir la carte des emplacements
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-340" data-mp="5o5v1etvl6ja" />
            </Link>
          </div>

          <ul className="mt-10 divide-y-[3px] divide-noir border-y-[3px] border-noir" data-id="element-341" data-mp="o1ly9vare33">
            {tour.map(stop => <li key={stop.day} className="grid grid-cols-2 items-center gap-4 py-4 md:grid-cols-[140px_1fr_auto]" data-id="element-342" data-mp="1h1i17wd3y18m">
                <span className="font-display text-xl uppercase leading-none" data-id="element-343" data-mp="27eepm9kemzhe">{stop.day}</span>
                <span className="col-span-2 md:col-span-1" data-id="element-344" data-mp="2ccpx4dn88xwg">
                  <span className="block font-semibold" data-id="element-345" data-mp="2cd81jxk1mifg">{stop.place}</span>
                  <span className="text-sm text-noir/60" data-id="element-346" data-mp="2hb9oitklb1w7">{stop.city}</span>
                </span>
                <span className="justify-self-end border-[3px] border-noir bg-creme px-3 py-1 text-sm font-semibold" data-id="element-347" data-mp="2mbxct7hfp4mq">
                  {stop.hours}
                </span>
              </li>)}
          </ul>
        </div>
      </section>

      <section className="bg-rouge py-16 md:py-20" data-id="element-348" data-mp="302kb4yja8sia">
        <div className="mx-auto flex max-w-5xl flex-col items-center gap-6 px-4 text-center md:px-8" data-id="element-349" data-mp="303vcyst63q6r">
          <h2 className="font-display text-3xl uppercase leading-[0.95] text-creme md:text-5xl" data-id="element-350" data-mp="350c4zy3hmop4">
            Faim maintenant ?
            <br data-id="element-351" data-mp="39yneg7pvex6t" />
            <span className="text-jaune" data-id="element-352" data-mp="3e2bmeriezusl">Commandez, on emballe.</span>
          </h2>
          <p className="max-w-xl text-creme/85" data-id="element-353" data-mp="3dzz58gkhdogl">
            Click &amp; collect au camion en 15 minutes, ou retrait sur place au laboratoire.
          </p>
          <Link to="/commander" className="inline-flex items-center gap-2 border-[3px] border-noir bg-jaune px-7 py-4 font-display text-lg uppercase text-noir shadow-hard transition-transform duration-150 ease-out hover:-translate-y-1" data-id="element-354" data-mp="ycbtccakga7x">
            Commander en ligne
            <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-355" data-mp="1m1nxuyuy7u3w" />
          </Link>
        </div>
      </section>
    </main>;
}